module.exports = __webpack_public_path__ + "img/act_create.f5d50de2.png";